export const SOURCE_TYPES = {
  ibms: 'ibms',
  commissioning: 'comm',
  comm: 'comm',
  commissioned: 'comm',
  direct: 'direct',
  debug: 'debug',
  retrieved: 'retrieved',
  diag: 'diag',
  '2hop': '2hop',
  unknown: 'unknown'
};

export const DEFAULT_METADATA_OBJ = [
  {
    az: null,
    el: null,
    rssi: null,
    pci: null,
    rsrp: null,
    rsrq: null
  },
  {
    az: null,
    el: null,
    rssi: null,
    pci: null,
    rsrp: null,
    rsrq: null
  },
  {
    az: null,
    el: null,
    rssi: null,
    pci: null,
    rsrp: null,
    rsrq: null
  }
];

export const HEATMAP_RETRIEVE_SCREEN_INDEXES = {
  SETTIMEOUT: 0,
  IN_PROGRESS: 1,
  SUCCESS: 2,
  DUPLICATE: 3,
  ERROR: 4
};
